export const PROCESSING_STATUS_LABELS = {
  UNAPPROVED: "Diajukan",
  DRAFT: "Draf",
  REJECTED: "Ditolak",
  PROCEED: "Terproses",
  QUEUE: "Menunggu diproses",
  CLOSED: "Ditutup",
  WAITING: "Sebagian diproses",

  // Legacy/local fallback. Do not use for new Accurate normalization.
  NOT_PENDING: "Tidak lagi pending",
  UNCONFIRMED: "Belum tersinkron",
  UNKNOWN: "Belum tersinkron",
};

export const APPROVAL_STATUS_LABELS = {
  UNAPPROVED: "Diajukan",
  DRAFT: "Draf",
  REJECTED: "Ditolak",
  APPROVED: "Disetujui",

  UNKNOWN: "Approval tidak dikenal",
};

export const PLANNING_STATUS_LABELS = {
  UNSCHEDULED: "Belum dijadwalkan",
  SCHEDULED: "Sudah dijadwalkan",
  BLOCKED: "Terblokir",
  COMPLETED: "Selesai",
};

export const SYNC_STATUS_LABELS = {
  QUEUED: "Menunggu giliran",
  RUNNING: "Sedang sinkronisasi",
  SUCCESS: "Berhasil",
  PARTIAL_SUCCESS: "Berhasil sebagian",
  FAILED: "Gagal",
};

export const ACTIVE_SYNC_STATUSES = new Set(["QUEUED", "RUNNING"]);

export const PENDING_PROCESSING_STATUSES = new Set(["QUEUE", "WAITING"]);

function normalizeStatus(status) {
  return String(status || "")
    .trim()
    .toUpperCase();
}

export function isPendingProcessingStatus(status) {
  return PENDING_PROCESSING_STATUSES.has(normalizeStatus(status));
}

export function isPendingSalesOrderStatus({ approvalStatus, processingStatus }) {
  return (
    normalizeStatus(approvalStatus) === "APPROVED" &&
    isPendingProcessingStatus(processingStatus)
  );
}

export function getProcessingStatusLabel(status) {
  const normalizedStatus = normalizeStatus(status);

  return (
    PROCESSING_STATUS_LABELS[normalizedStatus] ||
    status ||
    "Tidak diketahui"
  );
}

export function getApprovalStatusLabel(status) {
  const normalizedStatus = normalizeStatus(status);

  return APPROVAL_STATUS_LABELS[normalizedStatus] || status || "Tidak diketahui";
}

export function getPlanningStatusLabel(status) {
  const normalizedStatus = normalizeStatus(status);

  return PLANNING_STATUS_LABELS[normalizedStatus] || status || "Tidak diketahui";
}

export function getSyncStatusLabel(status) {
  const normalizedStatus = normalizeStatus(status);

  return SYNC_STATUS_LABELS[normalizedStatus] || "Belum pernah sinkronisasi";
}